import { createApp } from 'vue'
import './style.css'

import './assets/styles/font.css';
import 'devextreme/dist/css/dx.material.purple.light.css';
// import './css/dx.material.custom-purple.css'
import App from './App.vue'
import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-license.ts'; 
import {VueQueryPlugin} from "@tanstack/vue-query";
import {createPinia} from "pinia";




const pinia = createPinia();
const app = createApp(App);
app.use(pinia);

config({ licenseKey }); 
VueQueryPlugin.install(app,{
    queryClientConfig:{
        defaultOptions:{
            queries:{
                gcTime: 1000 * 60, // 1 minuto
            }
        }
    }
}) 
document.addEventListener("DOMContentLoaded", () => {
    
          app.mount('#app')
        
  });
